import { DataStore } from "aws-amplify/datastore";
import { Vet } from "../../models";
import { VetRepository } from "../interfaces";
import { VetRecord } from "../types";

const toVetRecord = (v: Vet): VetRecord => ({
  id: v.id,
  name: v.name,
  phoneNumber: v.phoneNumber,
  address: v.address,
});

export class DatastoreVetRepository implements VetRepository {
  async list(): Promise<VetRecord[]> {
    return (await DataStore.query(Vet)).map(toVetRecord);
  }

  async save(vet: Partial<VetRecord> & { id?: string }): Promise<VetRecord> {
    return toVetRecord(await DataStore.save(new Vet({ name: vet.name ?? "", ...vet })));
  }

  async update(vet: VetRecord): Promise<void> {
    const original = await DataStore.query(Vet, vet.id);
    if (!original) throw new Error("Failed to find vet to update");
    await DataStore.save(Vet.copyOf(original, (draft) => { Object.assign(draft, vet); }));
  }

  async delete(id: string): Promise<void> {
    await DataStore.delete(Vet, id);
  }
}
